import newsletterTranslation from './index.json';

export default newsletterTranslation;
